class Navdrawer extends HTMLElement {
  constructor() {
    super();

    this.slideParent = this.querySelector(".navdrawer__slide");
    this.slideGroupParent = this.querySelector(".navdrawer__slide-group");
    this.slideNodeList = this.slideGroupParent.querySelectorAll(
      ".navdrawer__slideItem"
    );

    this.navDrawerMain = this.querySelector(".nav__drawer-main-list");
    this.navDrawerControlList =
      this.navDrawerMain.querySelectorAll("navdrawer-control");

    this.slidesById = {};
    this.slideNodeList.forEach((slide) => {
      this.slidesById[slide.id] = slide;
    });

    this.activeSlide;
  }

  closeSlideDrawer() {
    this.slideParent.removeAttribute("open");
  }

  listenForCloseDrawer() {
    this.closeControlList = this.querySelectorAll(".navdrawer__slide-back");

    this.closeControlList.forEach((elem) => {
      elem.addEventListener("click", this.closeSlideDrawer.bind(this));
    });
  }

  hideActiveSlide() {
    this.activeSlide.removeAttribute("open");
  }

  refreshSlide(activeSlide) {
    // Controls that only link (no slide rendered for them) have nothing to open.
    if (!this.slidesById[activeSlide]) return;

    if (this.activeSlide) {
      this.hideActiveSlide();
    }

    this.activeSlide = this.slidesById[activeSlide];
    this.activeSlide.setAttribute("open", "");
    this.slideParent.setAttribute("open", "");
  }

  connectedCallback() {
    this.listenForCloseDrawer();

    setTimeout(() => {
      this.classList.remove("preinit");
    }, 400);
  }
}

class NavdrawerControl extends HTMLElement {
  constructor() {
    super();
    this.navdrawer = document.querySelector("nav-drawer");
  }

  onInteraction(event) {
    if (event && this.hasAttribute("data-ignore-link")) {
      event.preventDefault();
    }

    this.navdrawer.refreshSlide(this.getAttribute("for"));
  }

  listenForInteraction(e) {
    this.addEventListener("click", this.onInteraction.bind(this));
  }

  connectedCallback() {
    this.listenForInteraction();
  }
}

customElements.define("nav-drawer", Navdrawer);
customElements.define("nav-drawer-control", NavdrawerControl);
